module.exports = __webpack_public_path__ + "img/erjian_gaoji.74df89b7.png";